import React from "react";

interface ItemNameComponentProps {
  itemName: string;
}

const ItemNameComponent = ({ itemName }: ItemNameComponentProps) => {
  return <h3 className="text-lg font-semibold text-gray-900">{itemName}</h3>;
};

export default ItemNameComponent;
